/* B2B success measurement and first-party source evidence. No contact PII is read. */
(function () {
  'use strict';
  if (window.kb2bTrackingLoaded) return;
  window.kb2bTrackingLoaded = true;
  var measurementId = 'G-RH7368MDBL';
  var maxAge = 24 * 60 * 60 * 1000;
  var memory = {};
  function read(key) {
    for (var i = 0; i < 2; i++) {
      try {
        var value = JSON.parse(window[i ? 'localStorage' : 'sessionStorage'].getItem(key));
        if (value && Date.now() - value.time < maxAge) return value;
      } catch (e) { /* Storage is optional. */ }
    }
    return memory[key] || null;
  }
  function write(key, value) {
    memory[key] = value;
    // Prefer tab-scoped storage; use local storage only when it is unavailable.
    for (var i = 0; i < 2; i++) {
      try { window[i ? 'localStorage' : 'sessionStorage'].setItem(key, JSON.stringify(value)); return; }
      catch (e) { /* Try the next storage option. */ }
    }
  }
  function id() {
    return window.crypto && window.crypto.randomUUID ? window.crypto.randomUUID() :
      Date.now().toString(36) + '-' + Math.random().toString(36).slice(2);
  }
  function historyRead(key) {
    try { return window.history.state && window.history.state[key]; } catch (e) { return null; }
  }
  function historyWrite(key, value) {
    try {
      var state = Object.assign({}, window.history.state || {});
      state[key] = value;
      window.history.replaceState(state, '', window.location.href);
    } catch (e) { /* Sandboxed previews may not support history. */ }
  }
  var params = new URLSearchParams(window.location.search);
  var fields = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_id', 'utm_content', 'utm_term',
    'gclid', 'gbraid', 'wbraid', 'gad_source', 'gad_campaignid'];
  var referrer = '';
  try {
    var ref = new URL(document.referrer);
    if (ref.hostname !== window.location.hostname) referrer = ref.origin;
  } catch (e) { /* Direct entry. */ }
  var evidence = {};
  fields.forEach(function (key) {
    if (params.get(key)) evidence[key] = params.get(key).slice(0, 500);
  });
  var source = read('kb2b_source_v3');
  // Internal navigation and direct returns preserve the last observed external touch.
  if (Object.keys(evidence).length || referrer || !source) {
    source = { time: Date.now(), values: evidence, landing_path: window.location.pathname,
      referrer_origin: referrer, evidence_type: Object.keys(evidence).length ? 'campaign_parameters' :
        (referrer ? 'external_referrer' : 'direct_or_unknown') };
    write('kb2b_source_v3', source);
  }

  // Load at the landing page, so native GA4 can associate later inquiries with the visit.
  window.dataLayer = window.dataLayer || [];
  window.gtag = window.gtag || function () { window.dataLayer.push(arguments); };
  var configured = window.dataLayer.some(function (item) {
    return item && item[0] === 'config' && item[1] === measurementId;
  });
  if (!configured) {
    window.gtag('js', new Date());
    window.gtag('config', measurementId);
  }
  if (!document.querySelector('script[src*="googletagmanager.com/gtag/js"]')) {
    var script = document.createElement('script');
    script.async = true;
    script.src = 'https://www.googletagmanager.com/gtag/js?id=' + measurementId;
    document.head.appendChild(script);
  }

  document.querySelectorAll('[data-b2b-tracking]').forEach(function (marker) {
    var form = marker.closest('form');
    if (!form || form.dataset.b2bBound) return;
    form.dataset.b2bBound = 'true';
    var key = 'kb2b_submission_v3:' + window.location.pathname + ':' + form.id;
    var pending = read(key);
    var historical = historyRead(key);
    var confirmed = marker.dataset.success === 'true';
    var failed = marker.dataset.errors === 'true';
    var urlConfirmed = params.get('contact_posted') === 'true';
    var inFlight = false;
    var current = null;

    function hidden(name, value) {
      var input = form.querySelector('[name="contact[' + name + ']"]');
      if (!input) {
        input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'contact[' + name + ']';
        form.appendChild(input);
      }
      input.value = value;
    }
    function prepare() {
      if (!current) current = { id: id(), time: Date.now(), source: source, status: 'pending' };
      hidden('Inquiry ID', current.id);
      hidden('Attribution evidence', JSON.stringify(current.source));
    }
    prepare();
    form.addEventListener('submit', function () {
      if (!form.checkValidity()) return;
      prepare();
      write(key, current);
      historyWrite(key, null);
    });

    // A query parameter alone is not proof of a real inquiry.
    if (failed || (!confirmed && !(urlConfirmed && pending && pending.status === 'pending'))) return;
    if (historical && (!pending || pending.id === historical.id)) pending = historical;
    if (!pending) pending = { id: id(), time: Date.now(), source: source, status: 'pending' };
    if (pending.status === 'processed') return;
    // History provides refresh protection even when both storage APIs are blocked.
    historyWrite(key, pending);
    write(key, pending);
    function send() {
      if (inFlight) return;
      inFlight = true;
      var context = pending.source || source;
      window.gtag('event', 'b2b_quote_submit', {
        send_to: measurementId,
        form_name: 'b2b_quote',
        form_source: marker.dataset.formSource || '',
        inquiry_id: pending.id,
        source_evidence: context.evidence_type,
        inquiry_utm_source: (context.values.utm_source || '').slice(0, 100),
        inquiry_utm_medium: (context.values.utm_medium || '').slice(0, 100),
        inquiry_utm_campaign: (context.values.utm_campaign || '').slice(0, 100),
        transport_type: 'beacon',
        event_callback: function () {
          // This acknowledges tag processing, NOT receipt by Google's reporting backend.
          pending.status = 'processed';
          var latest = read(key);
          if (!latest || latest.id === pending.id) {
            write(key, pending);
            historyWrite(key, pending);
          }
        }
      });
    }
    send();
  });
})();
